import {createContext, useCallback, useContext, useEffect, useMemo, useState} from "react";
import {IAuthContext, IUser} from "../../models/auth";
import AuthService from "../../services/auth-service";
import Toast from "../../components/toast";

const AuthContext = createContext({} as IAuthContext);
export const AccessToken = "token";

export function AuthProvider({children}: { children: any }) {
  const [accessToken, setAccessToken] = useState<string>();

  useEffect(() => {
    const accessTokenLocalStorage = localStorage.getItem(AccessToken);
    if (accessTokenLocalStorage) {
      setAccessToken(accessTokenLocalStorage);
    } else {
      setAccessToken(undefined);
    }
  }, [accessToken]);


  const handleLogin = useCallback(
    async (user: IUser) => {
      const result = await AuthService.auth(user);
      if (typeof result === "string") {
        setAccessToken(result);
        localStorage.setItem(AccessToken, result);
        Toast.success("Login realizado com sucesso!");
      }
    }, []
  );


  const handleLogout = useCallback(() => {
      localStorage.removeItem(AccessToken);
      setAccessToken(undefined);
    }, []
  );


  const isAuthenticated = useMemo(() =>
    accessToken !== undefined, [accessToken]
  );

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login: handleLogin,
        logout: handleLogout
      }}
    >
      {children}
    </AuthContext.Provider>
  );

}

export const useAuthContext = () => useContext(AuthContext);
